import initializeForm from './initializeForm';
import setIsNewRecord from './setIsNewRecord';
import toggleModal from './toggleModal';

export default (systemId, item) => (dispatch) => {
    const newValues = item
        ? {
              id: item.id,
              system_id: systemId,
              system_uniqueid: item.system_uniqueid,
              ...item.preset_configuration,
          }
        : {};

    dispatch(initializeForm(newValues));
    dispatch(setIsNewRecord(false));
    dispatch(toggleModal(true));
};
